export enum EVerticalDropsTypes {
    NotSet,
    UnlinedVerticalDrop, // isCouterweir false
    UnlinedPoolAndCountweir, // isCouterweir true e isstiling false
    LinedPoolAndCountweirWithoutScoutDepth, // isCouterweir true e isStilingBasin true e stillingBasinElevation === 0
    LinedPoolAndCountweirWithNegativeScoutDepth, // isCouterweir true e isStilingBasin true e stillingBasinElevation < 0
}

export enum EDissipation {
    Automated,
    Manual,
}
